export default "__VITE_ASSET__DIQCaVgx__"